import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Calendar from '../components/Calendar';
import UpcomingEvents from '../components/UpcomingEvents';
import config from '../config/config';
import './Dashboard.css';

const Dashboard = () => {
  const navigate = useNavigate();
  const { user, canAccess } = useAuth();

  return (
    <div className="dashboard">
      {/* Header */}
      <div className="dashboard-header">
        <div className="header-content">
          <h1 className="dashboard-title">
            Bonjour, {user?.username} 👋
          </h1>
          <p className="dashboard-subtitle">
            Voici un aperçu de votre activité aujourd'hui
          </p>
        </div>
        <div className="header-actions">
          <button
            className="btn btn-primary"
            onClick={() => navigate('/add-event')}
          >
            Nouvel Événement
          </button>
        </div>
      </div>


      {/* Main Content Grid */}
      <div className="dashboard-grid">
        {/* Calendar Section */}
        <div className="calendar-section">
          <div className="section-header">
            <h2 className="section-title">Calendrier des Événements</h2>
            <button
              className="btn btn-secondary btn-sm"
              onClick={() => navigate('/events')}
            >
              Voir tout
            </button>
          </div>
          <div className="calendar-container">
            <Calendar />
          </div>
        </div>

        {/* Upcoming Events */}
        <div className="upcoming-events-section">
          <div className="section-header">
            <h2 className="section-title">Événements à Venir</h2>
            <button
              className="btn btn-secondary btn-sm"
              onClick={() => navigate('/events')}
            >
              Voir tout
            </button>
          </div>
          <div className="upcoming-events-container">
            <UpcomingEvents apiUrl={config.API_URL} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
